import {Box, InputLabel, MenuItem, Select, Typography} from "@mui/material";
import {lineWidthChoices} from "../../utils/choices";
import {memo} from "react";

const MhdLineWidthChoices = ({ label, value, onChange, disabled }) => {
  return (
    <>
      <InputLabel variant='primary'>
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
      {lineWidthChoices.map((choice) => (
        <MenuItem
          key={choice.value}
          value={choice.value}
        >
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: 1}}
          >
            <Box
              sx={{
                width: '100%',
                height: `${choice.label}px`,
                bgcolor: '#000000',
              }}
            />

          </Box>
        </MenuItem>
      ))}
      </Select>
    </>
  );
};

export default memo(MhdLineWidthChoices);